import { render, staticRenderFns } from "./Projet.vue?vue&type=template&id=3a15b8f5&"
import script from "./Projet.vue?vue&type=script&lang=ts&"
export * from "./Projet.vue?vue&type=script&lang=ts&"
import style0 from "./Projet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports